import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';
import messageTemplates from './sidebarItems/messageTemplates';
import automations from './sidebarItems/automations';

export const getSidebarItems = (accountId, options = {}) => ({
  primaryMenu: primaryMenu(accountId),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    automations(accountId),
    messageTemplates(accountId, options),
    reports(accountId, options),
    campaigns(accountId),
    settings(accountId, options),
    notifications(accountId),
  ],
});
